module.exports = __webpack_public_path__ + "img/cityimage.0c666eb9.png";